var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375.065,
    height: 314.672,
    viewBox: "0 0 375.065 314.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2e2e38;opacity:0.1;}.b{fill:#fff;}.c{fill:#2f2e41;}.d{fill:#f2f2f2;}.e{fill:#ccc;}.f{fill:#c981b2;}.g{fill:#d1d9d8;}.h{fill:#f08e8e;}.i{fill:#3f3d56;}.j{fill:#8482d9;}.k{fill:#42c9c2;}.l{fill:#ffb8b8;}.m{fill:#cfcce0;}.n{fill:#cad9e0;}.o{fill:#285173;}.p{fill:#214461;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1486.523 -362.665)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 181.438,
    cy: 16.91,
    rx: 181.438,
    ry: 16.91,
    transform: "translate(1498.711 643.518)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.523 55.682)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M355.192,377.966h-99.45a4.728,4.728,0,0,1-4.723-4.722V238.235a4.728,4.728,0,0,1,4.723-4.723h99.45a4.728,4.728,0,0,1,4.723,4.723V373.244a4.728,4.728,0,0,1-4.722,4.722Z",
    transform: "translate(1208.98 153.379)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M347.366,389.434a1.236,1.236,0,0,0-.608.213,18.181,18.181,0,0,0,2.722-.378Z",
    transform: "translate(1145.936 50.812)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M269.607,502.682",
    transform: "translate(1196.741 -23.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M355.192,377.966h-99.45a4.728,4.728,0,0,1-4.723-4.722V238.235a4.728,4.728,0,0,1,4.723-4.723h99.45a4.728,4.728,0,0,1,4.723,4.723V373.244a4.728,4.728,0,0,1-4.722,4.722Zm-99.45-143.9a4.172,4.172,0,0,0-4.167,4.167V373.244a4.172,4.172,0,0,0,4.167,4.167h99.45a4.172,4.172,0,0,0,4.167-4.167V238.235a4.172,4.172,0,0,0-4.167-4.167Z",
    transform: "translate(1208.98 153.379)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M441.136,327.607H412.995a2.226,2.226,0,1,1,0-4.453h28.141a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(1061.796 77.315)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M450.32,349.609H412.995a2.226,2.226,0,1,1,0-4.452H450.32a2.226,2.226,0,1,1,0,4.452Z",
    transform: "translate(1061.796 62.826)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360.128,434H290.04a2.226,2.226,0,1,1,0-4.453h70.088a2.226,2.226,0,1,1,0,4.453Z",
    transform: "translate(1184.751 24.288)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360.128,434H290.04a2.226,2.226,0,1,1,0-4.453h70.088a2.226,2.226,0,1,1,0,4.453Z",
    transform: "translate(1184.751 0.118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M369.312,456H290.04a2.226,2.226,0,1,1,0-4.453h79.272a2.226,2.226,0,1,1,0,4.452Z",
    transform: "translate(1184.751 9.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M369.312,456H290.04a2.226,2.226,0,1,1,0-4.453h79.272a2.226,2.226,0,1,1,0,4.452Z",
    transform: "translate(1184.751 -14.368)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360.128,506.572H290.04a2.226,2.226,0,0,1,0-4.453h70.088a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(1184.751 -23.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M369.312,528.574H290.04a2.226,2.226,0,1,1,0-4.453h79.272a2.226,2.226,0,1,1,0,4.453Z",
    transform: "translate(1184.751 -37.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360.128,579.145H290.04a2.226,2.226,0,1,1,0-4.453h70.088a2.226,2.226,0,1,1,0,4.453Z",
    transform: "translate(1184.751 -71.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M369.312,601.147H290.04a2.226,2.226,0,1,1,0-4.453h79.272a2.226,2.226,0,1,1,0,4.453Z",
    transform: "translate(1184.751 -85.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M734.271,278.722H634.82A4.728,4.728,0,0,1,630.1,274V138.99a4.728,4.728,0,0,1,4.723-4.723h99.451a4.728,4.728,0,0,1,4.722,4.723V274A4.728,4.728,0,0,1,734.271,278.722Z",
    transform: "translate(959.355 218.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M734.271,278.722H634.82A4.728,4.728,0,0,1,630.1,274V138.99a4.728,4.728,0,0,1,4.723-4.723h99.451a4.728,4.728,0,0,1,4.722,4.723V274A4.728,4.728,0,0,1,734.271,278.722Zm-99.451-143.9a4.172,4.172,0,0,0-4.167,4.167V274a4.172,4.172,0,0,0,4.167,4.167h99.451A4.172,4.172,0,0,0,738.438,274V138.99a4.172,4.172,0,0,0-4.167-4.167Z",
    transform: "translate(959.355 218.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M820.215,228.363H792.074a2.226,2.226,0,1,1,0-4.453h28.141a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(812.309 142.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M829.4,250.365H792.075a2.226,2.226,0,0,1,0-4.453H829.4a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(812.307 128.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M739.209,334.754H669.121a2.226,2.226,0,0,1,0-4.453h70.088a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(935.123 89.642)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M739.209,334.754H669.121a2.226,2.226,0,0,1,0-4.453h70.088a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(935.123 65.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M748.392,356.757H669.12a2.226,2.226,0,0,1,0-4.453h79.272a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(935.123 75.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M748.392,356.757H669.12a2.226,2.226,0,0,1,0-4.453h79.272a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(935.123 51.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M739.209,407.327H669.121a2.226,2.226,0,0,1,0-4.453h70.088a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(935.123 41.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M748.392,429.33H669.12a2.226,2.226,0,0,1,0-4.453h79.272a2.226,2.226,0,1,1,0,4.452Z",
    transform: "translate(935.123 27.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M739.209,479.9H669.121a2.226,2.226,0,0,1,0-4.453h70.088a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(935.123 -5.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M748.392,501.9H669.12a2.226,2.226,0,0,1,0-4.453h79.272a2.226,2.226,0,1,1,0,4.453Z",
    transform: "translate(935.123 -20.426)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M558.561,448.739H459.11a4.728,4.728,0,0,1-4.722-4.723V309.007a4.728,4.728,0,0,1,4.722-4.723h99.451a4.728,4.728,0,0,1,4.723,4.723V444.016A4.728,4.728,0,0,1,558.561,448.739Z",
    transform: "translate(1075.061 106.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M558.561,448.739H459.11a4.728,4.728,0,0,1-4.722-4.723V309.007a4.728,4.728,0,0,1,4.722-4.723h99.451a4.728,4.728,0,0,1,4.723,4.723V444.016A4.728,4.728,0,0,1,558.561,448.739ZM459.11,304.84a4.172,4.172,0,0,0-4.167,4.167V444.016a4.171,4.171,0,0,0,4.167,4.167h99.451a4.171,4.171,0,0,0,4.167-4.167V309.007a4.172,4.172,0,0,0-4.167-4.167Z",
    transform: "translate(1075.061 106.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M644.505,398.379H616.364a2.226,2.226,0,1,1,0-4.453h28.141a2.226,2.226,0,1,1,0,4.453Z",
    transform: "translate(927.878 28.843)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M653.688,420.382H616.364a2.226,2.226,0,1,1,0-4.453h37.324a2.226,2.226,0,1,1,0,4.453Z",
    transform: "translate(927.878 14.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M563.5,504.771H493.409a2.226,2.226,0,0,1,0-4.453H563.5a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(1050.831 -22.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M563.5,504.771H493.409a2.226,2.226,0,0,1,0-4.453H563.5a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(1050.831 -45.834)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M572.681,526.774H493.409a2.226,2.226,0,1,1,0-4.452h79.272a2.226,2.226,0,1,1,0,4.453Z",
    transform: "translate(1050.831 -36.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M572.681,526.774H493.409a2.226,2.226,0,1,1,0-4.452h79.272a2.226,2.226,0,1,1,0,4.453Z",
    transform: "translate(1050.831 -60.323)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M563.5,577.344H493.409a2.226,2.226,0,1,1,0-4.453H563.5a2.226,2.226,0,1,1,0,4.453Z",
    transform: "translate(1050.831 -70.106)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M572.681,599.347H493.409a2.226,2.226,0,1,1,0-4.453h79.272a2.226,2.226,0,1,1,0,4.453Z",
    transform: "translate(1050.831 -84.595)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M563.5,649.917H493.409a2.226,2.226,0,0,1,0-4.453H563.5a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(1050.831 -117.897)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M572.681,671.92H493.409a2.226,2.226,0,0,1,0-4.453h79.272a2.226,2.226,0,0,1,0,4.453Z",
    transform: "translate(1050.831 -132.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M713.765,637.268a21.935,21.935,0,1,0,0,43.869h0a21.934,21.934,0,1,0,0-43.869Z",
    transform: "translate(918.703 -112.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M733.168,690.533a2.662,2.662,0,0,1-1.6-.532l-.029-.021-6.032-4.614a2.681,2.681,0,1,1,3.262-4.255l3.907,3,9.233-12.045a2.68,2.68,0,0,1,3.756-.5h0l-.057.08.059-.08a2.683,2.683,0,0,1,.5,3.758L735.3,689.485a2.681,2.681,0,0,1-2.132,1.045Z",
    transform: "translate(897.218 -134.72)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19467.012 21155.016)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M706.136,398.628s-17.227,13.536-8.614,16.612,14.151-11.075,14.151-11.075Z",
    transform: "translate(-18454.32 -21058.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M718.744,386.28l-3.692,6.153s6.153,0,7.383,9.229l4.922-6.153Z",
    transform: "translate(-18466.311 -21050.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M796.5,675.375l.615,18.458-7.383,4.307-3.076-1.846.615-20.919Z",
    transform: "translate(-18462.238 -21199.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M795.875,725.845l1.231,19.688-17.227,7.383,1.23-10.459s4.922-8,3.692-16.612Z",
    transform: "translate(-18505.297 -21254.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M812.121,353.868s9.844,25.841,11.69,41.838,4.922,58.45,4.922,58.45l6.153,61.471-17.227,2.461L810.275,456l-16.612-54.758L789.971,456,786.9,512.549l-16,.615-1.23-58.395L762.9,388.938l3.692-31.378Z",
    transform: "translate(-18495.086 -21031.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M905.817,778.065s1.009-10.333,8.5-4.551l1.341-.986,6.152,13.536s7.383,10.459-5.537,11.69-11.69-11.69-11.69-11.69l-1.231-5.538.615-3.626Z",
    transform: "translate(-18579.553 -21282.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M764.316,756.714a9.773,9.773,0,0,1,4.922,8.613c0,6.152-.615,6.768-.615,6.768l-9.229,2.461s-6.152-.615-9.844,3.076-22.149,6.153-22.149,1.231,15.381-12.921,15.381-12.921,4.568-7.714,7.821-6.934,4.484,2.011,4.484,2.627a42.4,42.4,0,0,1-1.846,4.922S763.7,764.1,764.316,756.714Z",
    transform: "translate(-18473.738 -21273.471)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 15.381,
    cy: 15.381,
    rx: 15.381,
    ry: 15.381,
    transform: "translate(-17726.033 -20783.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M819.737,135.466l6.768,15.381L808.048,177.3s-1.231-28.917-4.922-33.839S819.737,135.466,819.737,135.466Z",
    transform: "translate(-18519.008 -20899.865)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M671.278,117.637l3.077-8,2.46.615,3.077-2.461L684.2,94.257l6.153,4.307,8,80.6-49.836,1.231,6.768-55.989,6.153-16,4.441-5.871,2.942,8.947Z",
    transform: "translate(-18379.162 -20850.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M859.367,218.2l1.883-55.655s3.655.282,4.885,2.128,21.534,5.537,21.534,5.537l-3.691,57.219s15.381,45.529,9.844,47.99-15.382,1.846-15.382,1.846Z",
    transform: "translate(-18553.1 -20916.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M760.216,227.822l6.527-37.509-14.525,9.823,3.692,27.071-3.076,18.458s-11.69,51.067-8,52.913,8,0,8,0l7.383-51.682Z",
    transform: "translate(-18483.789 -20932.848)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M739.047,211.868,734.74,213.1l-1.846,24.61-3.076,21.534L715.052,285.7s7.383-4.922,10.459,9.229l16.262-28.312Z",
    transform: "translate(-18466.311 -20945.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M879.005,386.28s-17.227,13.536-8.613,16.612,14.151-11.075,14.151-11.075Z",
    transform: "translate(-18558.279 -21050.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M784.14,322.8l-5.537,6.768-7.383-12.921,3.076-5.537Z",
    transform: "translate(-18452.953 -20980.455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M901.155,183.459,906.077,181s3.692,4.922,4.307,9.229,3.691,9.844,3.691,12.92,8.614,31.994,8.614,31.994L903,275.133s-4.307-14.766-13.536-16L904.847,237.6l-8.614-15.382Z",
    transform: "translate(-18571.199 -20927.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M795.673,72.824l1.757.833s-4.922-8.671-13.36-8.091l2.373-.452s-5.8-4.483-11.075,1.613c-2.772,3.2-5.98,6.972-7.979,11.215l-1.029.978-.661,1.742-.126,3.193.126-.716a15.96,15.96,0,0,0-.126,4.735,6.127,6.127,0,0,0,2.244,4.008h0s3.6-7.446,3.6-8.607l-2.29,4.6s5.191-4.309,5.191-6.051l-1.171,2.032,3.544-3.193,9.756,3.193,4.483-1.742,4.746-.835-7.119-2.358s6.856,3.774,7.119,6.967a15.333,15.333,0,0,0,2.27,6.219S803.32,77.179,795.673,72.824Z",
    transform: "translate(-18493.447 -20855.877)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 1.723,
    cy: 2.153,
    rx: 1.723,
    ry: 2.153,
    transform: "translate(-17699.764 -20773.012)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/Overview.ddbce0f10649ee7bad7ac50e2e020c33.svg";
export { ForwardRef as ReactComponent };